import { type UseQueryOptions, useQuery } from "@tanstack/react-query";

import GoogleClient from "../clients/GoogleClient";
import { type ApiClientClass, useApi } from "./useApi";

export type AddressSearchOption = {
  label: string;
  value: string;
};

export const useGoogleAddressSearch = (search: string, options: UseQueryOptions<AddressSearchOption[]> = {}) => {
  const googleApi = useApi(GoogleClient as unknown as ApiClientClass<GoogleClient>);

  return useQuery<AddressSearchOption[]>(
    ["places-search", search],
    async () => {
      const data = await googleApi.autocomplete(search);
      return data ?? [];
    },
    {
      enabled: !!search,
      refetchOnReconnect: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
      ...options,
    },
  );
};
